import styled from 'styled-components';

export const Wrapper = styled.button`
  height: 24px;
  width: 20px;
  position: relative;
  font-size: 12px;
  cursor: pointer;
  transition: .2s all;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  appearance: none;
  outline: none;
  background: none;
  border: 0;

  .burger-lines {
    &:after {
      left: 0;
      top: -7px;
    }

    &:before {
      left: 0;
      top: 7px;
    }

    &,
    &:after,
    &:before {
      transition: .2s top .2s, .1s left, .2s transform, .4s background-color .2s;
    }
    &:after,
    &:before {
      width: 100%;
    }
  }

  /* &:after {
    content: '';
    display: block;
    position: absolute;
    height: 150%;
    width: 150%;
    top: -25%;
    left: -25%;
  } */
  .burger-lines {
    top: 50%;
    margin-top: -1px;
    left: 0;

    &,
    &:after,
    &:before {
      pointer-events: none;
      display: block;
      content: '';
      width: 100%;
      border-radius: 0.25em;
      background-color: white;
      height: 2px;
      position: absolute;
      transform: rotate(0);
    }
    &:after {
      left: 0;
      top: -7px;
    }
    &:before {
      left: 0;
      top: 7px;
    }
  }

  &.open {
    .burger-lines {
      &,
      &:after,
      &:before {
        transition: .2s background-color, .2s top, .2s left, .2s transform .15s;
      }
      & {
        background-color: transparent;
      }
      &:before,
      &:after {
        /* left: 0.5em; */
        top: 0px;
      }
      &:before {
        transform: rotate(-45deg);
      }
      &:after {
        transform: rotate(45deg);
      }
    }
  }
`;